
import {Admin} from "@/models/admin";
import {AdminsService} from "@/services/admins-service";
import {AuthService} from "@/services/auth-service";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			admins: [] as Admin[],
			toEditAdmin: null as null | Admin,
			loggedInAdmin: AuthService.user as | Admin
		};
	},
	computed: {
		availablePermissions(): string[] {
			return [
				"companies.read",
				"companies.write",
				"tickets",
				"metrics",
				"admin",
				"statistics",
				"scripts"
			];
		}
	},
	methods: {
		async fetch() {
			this.admins = await AdminsService.getAdmins();
		},
		editAdmin(admin: Admin) {
			this.toEditAdmin = new Admin(admin);
		},
		setPermission(admin: Admin, permission: string, value: boolean) {
			if (value) {
				if (this.hasPermission(admin, permission)) return;
				admin.permissions.push(permission);
				if (permission == "companies.write") {
					this.setPermission(admin, "companies.read", true);
				}
			} else {
				if (!this.hasPermission(admin, permission)) return;
				admin.permissions.splice(admin.permissions.indexOf(permission), 1);
				if (permission == "companies.read") {
					this.setPermission(admin, "companies.write", false);
				}
			}
		},
		cancel() {
			this.toEditAdmin = null;
		},
		async save() {
			if (!this.toEditAdmin) return;
			await AdminsService.setPermissions(this.toEditAdmin.id, this.toEditAdmin.permissions);
			this.fetch();
			this.toEditAdmin = null;
		},
		adminPermissionsToString(admin: Admin): string {
			return admin.permissions.join(", ");
		},
		hasPermission(admin: Admin, permission: string): boolean {
			return admin.permissions.indexOf(permission) != -1;
		}
	},
	created() {
		this.fetch();
	}
});
